/* =====================================================================
   Mega menu tabs — toggle product panes based on active button
   ----------------------------------------------------------------------
   Convention :
   - Container : .mm-tabs-host
   - Buttons   : .mm-tab.mm-tab-{eyes|masques|packs} (inside container)
   - Panes     : .mm-pane.mm-pane-{eyes|masques|packs} (inside container)
   - Active state class : .is-active (added/removed by JS)
   - Default active : "eyes"

   Perf (v64) : les images des cartes du header (mega menu desktop et
   accordeon mobile) sont en loading="lazy" (blocks/image-card.liquid),
   donc elles ne se chargent plus au chargement de la page alors qu'elles
   sont masquees. Pour eviter un flash de cartes vides a l'ouverture du
   menu, on les prechauffe : des que la page a fini de charger (apres un
   court delai) ou des que la souris survole le menu, on passe en eager
   les images de la version qui correspond a l'ecran (desktop OU mobile),
   ce qui declenche leur chargement en arriere-plan.
   ===================================================================== */

(function () {
  'use strict';

  var TABS = ['eyes', 'masques', 'packs'];
  var DEFAULT = 'eyes';

  function activateTab(host, target) {
    if (!host || !target) return;

    // Update buttons
    TABS.forEach(function (t) {
      var tab = host.querySelector('.mm-tab.mm-tab-' + t);
      if (tab) tab.classList.toggle('is-active', t === target);
    });

    // Update panes
    TABS.forEach(function (t) {
      var pane = host.querySelector('.mm-pane.mm-pane-' + t);
      if (pane) pane.classList.toggle('is-active', t === target);
    });
  }

  function bindHost(host) {
    if (!host || host.dataset.mmTabsBound === 'true') return;
    host.dataset.mmTabsBound = 'true';

    // Click handler for tab buttons (event delegation)
    host.addEventListener('click', function (e) {
      var tabEl = e.target.closest('.mm-tab');
      if (!tabEl || !host.contains(tabEl)) return;

      // Find the target from class name (mm-tab-{name})
      var match = tabEl.className.match(/\bmm-tab-(eyes|masques|packs)\b/);
      if (!match) return;

      // Onglet deja actif (cas normal a la souris, le survol l'a active) :
      // on laisse le lien du bouton naviguer.
      if (tabEl.classList.contains('is-active')) return;

      // Onglet inactif (ecran tactile, pas de survol) : le premier appui
      // affiche le panneau, le second suivra le lien.
      e.preventDefault();
      e.stopPropagation();

      activateTab(host, match[1]);
    }, true); // capture phase to beat any underlying link nav

    // Hover handler — also switch on mouseenter for snappier UX
    TABS.forEach(function (t) {
      var tabEl = host.querySelector('.mm-tab.mm-tab-' + t);
      if (!tabEl) return;
      tabEl.addEventListener('mouseenter', function () {
        activateTab(host, t);
      });
    });

    // Prechauffage immediat au survol du menu (desktop)
    host.addEventListener('pointerenter', warmMenuImages, { once: true });

    // Initial state : DEFAULT tab active
    activateTab(host, DEFAULT);
  }

  /* Passe en eager les images lazy du menu correspondant a l'ecran.
     Desktop : les cartes du mega menu (dropdown-component).
     Mobile  : les cartes de l'accordeon du menu tiroir (.hma-item). */
  var warmed = false;
  function warmMenuImages() {
    if (warmed) return;
    warmed = true;
    var desktop = window.matchMedia('(min-width: 750px)').matches;
    var selector = desktop
      ? 'dropdown-component img[loading="lazy"]'
      : '.hma-item img[loading="lazy"]';
    document.querySelectorAll(selector).forEach(function (img) {
      img.loading = 'eager';
    });
  }

  function scheduleWarm() {
    var run = function () { setTimeout(warmMenuImages, 2500); };
    if (document.readyState === 'complete') {
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  function init() {
    var hosts = document.querySelectorAll('.mm-tabs-host');
    hosts.forEach(bindHost);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  scheduleWarm();

  // Re-bind if DOM is mutated (Shopify section reloads, theme editor)
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
